import { useCallback } from "react";
import { useHistory } from "react-router";
import {
  AirPFExerciseSelectors,
  useCheckoutSend,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { PriceFreezeExerciseErrorModal } from "@hopper-b2b/fintech";
import { useChatSupport } from "@hopper-b2b/self-serve";

import { PATH_TRIPS } from "../../../utils/urlPaths";
import { Event, type TEvent } from "../events";

export interface IPriceFreezeErrorModal {
  openModal: boolean;
}

export const PriceFreezeErrorModal = ({
  openModal,
}: IPriceFreezeErrorModal) => {
  const { generalSupportChat } = useChatSupport();
  const send = useCheckoutSend<TEvent>();
  const history = useHistory();

  const priceFreezeId =
    useSelector(AirPFExerciseSelectors.getPriceFreezeId) ?? "";
  const priceFreezePassengerQuantity = useSelector(
    AirPFExerciseSelectors.getPriceFreezePassengers
  );
  const priceFreezeTotalAmount = useSelector(
    AirPFExerciseSelectors.getPriceFreezeTotalAmount
  )?.fiat;
  const sendToInitialStep = useCallback(() => {
    send(Event.GO_TO_PASSENGER_SELECT);
  }, [send]);

  const sendToTripsList = useCallback(() => {
    history.push(PATH_TRIPS);
  }, [history]);

  const sendToContactSupport = useCallback(() => {
    generalSupportChat();
  }, [generalSupportChat]);

  return (
    <PriceFreezeExerciseErrorModal
      handleTryAgainCheckout={sendToInitialStep}
      handleContinue={sendToTripsList}
      handleContactCustomerService={sendToContactSupport}
      priceFreezeId={priceFreezeId}
      openModal={openModal}
      priceFreezeTravelerQuantity={priceFreezePassengerQuantity}
      priceFreezeTotalAmount={priceFreezeTotalAmount}
    />
  );
};
